export default __webpack_public_path__ + "static/media/briefcase_blue.09eea174.svg";